export default __webpack_public_path__ + "static/media/3_1013_1116_Grida.67e8ece3.nproj";